import React from 'react';
import './OurTutors.css'; // Dedicated page styles
import CertifiedTutors from '../components/CertifiedTutors';

const OurTutors = () => {
  return (
    <div className="about-page" id="our-tutors-page">
      {/* Premium Hero Section */}
      <section
        className="about-hero tutors-hero"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')`
        }}
      >
        <div className="about-hero__content">
          <h1 className="about-hero__title">
            Meet Your Quran Teachers Online<br />Chosen With Care, Trusted by Families
          </h1>
          <nav className="about-hero__breadcrumb" aria-label="breadcrumb">
            <a href="/" className="about-hero__breadcrumb-link">Home</a>
            <span className="about-hero__breadcrumb-separator">&gt;</span>
            <span className="about-hero__breadcrumb-current">Our Tutors</span>
          </nav>
        </div>
      </section>

      {/* Caring, Qualified Teachers Section */}
      <section
        className="tutors-features-section"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/hero-bottom.webp')`
        }}
      >
        <div className="tutors-features__container">
          <h2 className="tutors-features__heading">
            Caring, Qualified Teachers Who Understand Every Learner
          </h2>
          <div className="tutors-features__underline"></div>

          <div className="tutors-features__card">
            {/* Feature 1 */}
            <div className="tutors-features__item">
              <div className="tutors-features__icon-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/A-1.webp`}
                  alt="Qualified Teachers"
                  className="tutors-features__icon"
                />
              </div>
              <div className="tutors-features__text-wrapper">
                <h3 className="tutors-features__title">Qualified Male and Female Teachers</h3>
                <p className="tutors-features__description">
                  Our Quran teachers online aren't just qualified, they genuinely care. Each tutor is experienced in working with both children and adults, and trained to make sure every student pronounces Arabic correctly while feeling supported, never rushed or judged. Education here is built on patience, not pressure.
                </p>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="tutors-features__item">
              <div className="tutors-features__icon-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/A-2.webp`}
                  alt="Structured Lessons"
                  className="tutors-features__icon"
                />
              </div>
              <div className="tutors-features__text-wrapper">
                <h3 className="tutors-features__title">Structured Lessons for Beginners</h3>
                <p className="tutors-features__description">
                  We start every student from the <a href='/noorani-qaida-course/' className="tutors-features__highlight">Noorani Qaida</a> basics, so the foundation is solid before moving forward. Each lesson connects to the one before it, which means no confusion, no gaps, and no student left behind. It's a journey designed to build real confidence, not just memorized recitation.
                </p>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="tutors-features__item">
              <div className="tutors-features__icon-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/A-3.webp`}
                  alt="Learn Quran with Proper Pronunciation and Tajweed"
                  className="tutors-features__icon"
                />
              </div>
              <div className="tutors-features__text-wrapper">
                <h3 className="tutors-features__title">One-to-One Online Classes</h3>
                <p className="tutors-features__description">
                  In a one-on-one class, your child or you are the only focus, not one student among many. Our teachers listen closely, gently correct mistakes, and adjust their pace to match how you learn best. It's this personal attention that makes learning Quran online at home feel warm, encouraging, and genuinely effective.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certified Tutors Section */}
      <CertifiedTutors />

      {/* Quran Teachers Trust Section */}
      <section
        className="tutors-trust-section"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/hero-bottom.webp')`
        }}
      >
        <div className="tutors-trust__container">
          <div className="tutors-trust__content-col">
            <h2 className="tutors-trust__heading">
              Quran Teachers Online Your<br />Family Can Trust!
            </h2>
            <div className="tutors-trust__underline"></div>
            <a href="/free-trial/" className="tutors-trust__button">
              Book Your 3-Day Free Trial &rarr;
            </a>
          </div>
          <div className="tutors-trust__image-col">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/Al.png`}
              alt="Quran Teacher holding Quran"
              className="tutors-trust__img"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurTutors;


